export const COGNITO_DOMAIN =
  "https://ap-south-1bq93f3ffl.auth.ap-south-1.amazoncognito.com";

export const CLIENT_ID = "33s0hhe3rh36bhq9kmph4fiis5";

export const LOGIN_REDIRECT_URI =
  "https://d8hdjyf0a203v.cloudfront.net/callback";

export const LOGOUT_REDIRECT_URI =
  "https://d8hdjyf0a203v.cloudfront.net/";

export const API_BASE =
  "https://m18shwyr8a.execute-api.ap-south-1.amazonaws.com";
